<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import accidentAPI from "@/services/standards/accident/accidentAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI"
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification"
import CheckModal from "@/components/CheckModal"
import ItemAPI from "@/services/items/itemsAPI";
import CompanyAPI from "@/services/company/companyAPI";
import EmployeeAPI from "@/services/employee/employeeAPI";
import Pagination from "@/components/standard/Accident/AccidentPagination";
import newScoresAPI from "../../../services/newScores/newScoresAPI";

import { required } from 'vuelidate/lib/validators'
/**
 * Form elements component
 */
export default {
  page: {
    title: "3.2.1 Reporte de los incidentes, accidentes de trabajo y enfermedades laborales",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
    Pagination,
  },
  data() {

    return {
      submi: false,
      title: "3.2.1 Reporte de los incidentes, accidentes de trabajo y enfermedades laborales ",
      items: [

        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Reporte de los incidentes, accidentes de trabajo y enfermedades laborales",
          active: true,
        },
      ],

      information: true,
      lista: [],
      type: [],
      typeEvent: [],
      lesion: [],
      agente: [],
      parteAfectada: [],
      subtype: [],
      listaII: [],

      file: null,

      item: null,
      itemStatus: "No cumplido",
      loading1: true,
      itemData: null,

      accident: {
        accident_report_types_id: null,
        report_subtypes_id: null,
        accident_agents_id: null,
        injured_part_bodies_id: null,
        type_of_injuries_id: null,
        event_types_id: null,
        report_date: null,
        hour: null,
        description: null,
        improvement_plan: null,
        arl_report_date: null,
        file: null,
        site: null,
        employee_id: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
        company_classification_id: this.$store.getters["company/getCompany"].company_classification_id || null,
        items_id: 32,
      },
      submitted: false,

      itemsAgregar: {
        companies_id: this.$store.getters["company/getCompany"].id || null,
        items_id: 32,
        status: 1,
        operation: 'suma',
        company_classification_id: this.$store.getters["company/getCompany"].company_classification_id || null,
      },
      company: this.$store.getters["company/getCompany"] || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      usersList: [],

      itemcheck: {
        companies_id: this.$store.getters["company/getCompany"].id || null,
        items_id: 32,
      },

      exist: false,
      cantidad: false,
      deleteCount: 0,
      search: "",
      loading: true,

    };
  },

  validations: {
    accident: {
      accident_report_types_id: {
        required,
      },
      report_date: {
        required,
      },
      hour: {
        required,
      },
      description: {
      },
      improvement_plan: {
      },
      arl_report_date: {
      },
      site: {
        required,
      },
      file: {

      },
      employee_id: {
        required,
      },

    },
  },
  methods: {

    fetch() {
      this.loading = true;
      this.$refs.paginator.query();
    },

    getItem() {
      CompanyItemsAPI.getStatus(this.companyID, 32)
        .then(response => {
          this.exist = response.id
        })
        .catch(error => {
          console.log(error)
        })
    },

    getAccidents() {
      accidentAPI.getAllAccidents(this.companyID)
        .then((response) => {
          this.cantidad = response.Accident_report
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getUsers() {
      CompanyAPI.getCompany(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id)
            .then((res) => {
              this.usersList = res.employee
            })
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getItemData() {
      ItemAPI.getItems(32)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 32)
        .then(response => {
          this.item = response || null
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch(error => {
          console.log(error)
        })
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 32,
        status: itemStatus,
      };
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado del ítem con éxito!",
            icon: "success",
            type: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
        })
        .catch((error) => {
          Swal.fire({
            title: "¡ERROR!",
            text: "¡No se ha actualizado el estado del ítem!",
            icon: "error",
            type: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });

          setTimeout(() => window.location.reload(), 2000)
          console.log(error);
        });
    },

    /**
        * This method is used to send notification to SST user and SST company.
        * The sendNotification method import is required.
        * @param {Number} messageID - The message ID that will be associated to notification.
        * @param {Number} itemID - The item ID that will be associated to notification.
        * @param {Boolean} user - The user that will e associated to notification.
        * @return {Boolean} True if the notification is sent, false if not.
        */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },

    /**
    * This method is used to knows if the user has the permission indicated
    * @param {String} name The name of the permission
    * @param {Array} roles the roles that permitted to access the action 
    * @returns {Boolean} true if the user has the permission indicated or false if no
    */
    getRole(name, roles) {

      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null

      // If the user is logged
      if (role) {

        // If the roles array is not empty
        if (roles) {

          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false

        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {

          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8

        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions

        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false

      } // Close if the user is logged

      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
  */
    goPage(page) {
      window.location.href = page
    },

    getFile(file) {
      try {
        const name = file.split("/");
        return name[name.length - 1];
      } catch (error) {
        return file;
      }
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/3.2.1/${this.accident.employee_id}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.nit}/3.2.1/${this.accident.employee_id}/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.accident.file = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    getType() {
      accidentAPI.getType()
        .then((response) => {
          this.type = response.Accident_report_type;
        })
        .catch((error) => {
          console.log(error);

        });
    },

    getSubType() {
      accidentAPI.getType()
        .then((response) => {
          let typeAccident = response.Accident_report_type;
          this.type = typeAccident
          this.subtype = typeAccident[0].report_subtype
        })
        .catch((error) => {
          console.log(error);

        });
    },

    getTypeEvent() {
      accidentAPI.getTypeEvent()
        .then((response) => {
          this.typeEvent = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    gettypeOfInjury() {
      accidentAPI.gettypeOfInjury()
        .then((response) => {
          this.lesion = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getAccidentAgent() {
      accidentAPI.getAccidentAgent()
        .then((response) => {
          this.agente = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getInjuredPartBody() {
      accidentAPI.getInjuredPartBody()
        .then((response) => {
          let type = response.data;
          this.parteAfectada = type
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getList() {
      accidentAPI.getAllAccidentPage(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          this.lista = response.Accident_report.data;
          if (Array.isArray(this.lista)) {
            this.deleteCount = this.lista.length;
          } else {
            this.deleteCount = 0;
          }
          this.loading1 = false
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async save() {
      this.submitted = true;
      this.loading1 = true
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading1 = false
        this.submitted = false;
        return;
      } else {
        accidentAPI.save(this.accident)
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 32,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.sendNotification(30, 32, true)
                this.sendNotification(32, 32, true)
                this.loading1 = false
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Accidente creado con éxito!",
                    type: "success",
                    icon: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 2000)
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      }

    },

    deleteAccident(id) {
      accidentAPI.deleteAccident(id)
        .then((data) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';
          const itemChange = {
            companies_id: this.companyID,
            item_id: 32,
            status: newStatus,
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => { })
            .catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
          Swal.fire({
            title: "Éxito!",
            text: "Se ha sido eliminado con éxito!",
            type: "success",
            icon: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          window.location.reload();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

  },

  mounted() {
    this.getAccidents()
    this.getUsers();
    this.getItems()
    this.getItem()
    this.getList();
    this.getItemData();
    this.getType();
    this.getSubType();
    this.getTypeEvent();
    this.gettypeOfInjury();
    this.getAccidentAgent();
    this.getInjuredPartBody();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading1">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">

                  <CheckModal>
                    <p class="text-justify">
                      Reportar ante la ARL los accidentes e incidentes y enfermedades laborales y subir a este
                      aplicativo, la evidencia de dicho formulario, radicado en la ARL. Estos reportes se deben realizar
                      durante los dos días hábiles siguientes al evento.
                      De igual manera, se deberá reportar a la EPS del colaborador accidentado. Cuando son accidentes
                      graves o mortales, o se califica una enfermedad laboral, se deberá notificar a la Dirección
                      Territorial del Ministerio de Trabajo.
                      Subir en un archivo comprimido todas las evidencias de estas notificaciones.
                    </p>
                  </CheckModal>
                </div>

                <div class="col-6 text-right m-b-0">

                  <a href="/forms/accidentes" id="tooltip">
                    Información normativa sobre accidentes y enfermedades laborales
                  </a>

                  <b-tooltip target="tooltip" placement="left">
                    Ir a Formato único de reporte de presunto accidente de trabajo (FURAT)
                  </b-tooltip>
                </div>

              </div>

              <div class="row">
                <div class="col-6">
                </div>

                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>

              </div>

              <form :disabled="!getRole('Crear') || !allowAccess()" class="form-group" @submit.prevent="save">
                <!-- check for accidents -->
                <div class="form-row pt-3">
                  <a :href="`/forms/estandares/${companyID}/reporte-no-accidentes`" underline class="mx-1">
                    No han ocurrido accidentes / o incidentes para reportar
                  </a>
                </div>

                <div>

                  <div class="form-row pt-3">
                    <b-form-group class="col-md-6" label="Colaborador" label-for="employee">
                      <select :class="{
                        'is-invalid':
                          $v.accident.employee_id.$error && submitted,
                      }" id="employeeID" :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                        v-model="accident.employee_id">
                        <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                          {{ item.full_name }}
                        </b-form-select-option>

                      </select>
                      <div v-if="submitted && $v.accident.employee_id.$error">
                        <small v-if="!$v.accident.employee_id.required" class="text-danger">
                          <b>El campo es requerido</b>
                        </small>
                      </div>
                    </b-form-group>

                    <b-form-group label="Tipo" required label-for="tipo" inline class="col-sm-4 pl-4">
                      <label class="mr-2">
                        Accidente
                      </label>
                      <input :disabled="!getRole('Crear') || !allowAccess()" type="radio" style="color: #666" :value="1"
                        v-model="accident.accident_report_types_id" class="mb-2 mr-sm-2 mb-sm-0" label="accidente" />
                      <label class="mr-2 pl-sm-2 pl-md-0">
                        Incidente
                      </label>
                      <input :disabled="!getRole('Crear') || !allowAccess()" type="radio" :value="2"
                        v-model="accident.accident_report_types_id" class="mb-2 mr-sm-2 mb-sm-0" label="incidente" />
                      <label class="mr-2 pl-sm-2 pl-md-0">
                        Enfermedad laboral
                      </label>
                      <input :disabled="!getRole('Crear') || !allowAccess()" type="radio" :value="3"
                        v-model="accident.accident_report_types_id" class="mb-2 mr-sm-2 mb-sm-0" label="enfermedad" />
                    </b-form-group>

                  </div>

                  <div class="form-row mt-2 ml-4">

                    <b-form-group v-if="accident.accident_report_types_id == 1" id="report_type" label-for="type"
                      class="col-sm-2 mr-4" label="Tipo de accidente">

                      <select id="type" :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                        v-model="accident.report_subtypes_id">
                        <b-form-select-option v-for="tipo1 in subtype" :key="tipo1.id" :value="tipo1.id">
                          {{ tipo1.name }}
                        </b-form-select-option>
                      </select>

                    </b-form-group>

                    <b-form-group v-if="accident.accident_report_types_id == 1" id="report_type" label-for="type"
                      class="col-sm-2 mr-4" label="Tipo de evento">

                      <select id="type" :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                        v-model="accident.event_types_id">
                        <b-form-select-option v-for="tipo2 in typeEvent" :key="tipo2.id" :value="tipo2.id">
                          {{ tipo2.name }}
                        </b-form-select-option>
                      </select>

                    </b-form-group>
                    <b-form-group v-if="accident.accident_report_types_id == 1" id="report_type" label-for="type"
                      class="col-sm-2 mr-4" label="Tipo de lesión">

                      <select id="type" :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                        v-model="accident.type_of_injuries_id">
                        <b-form-select-option v-for="tipo3 in lesion" :key="tipo3.id" :value="tipo3.id">
                          {{ tipo3.name }}
                        </b-form-select-option>
                      </select>

                    </b-form-group>
                    <b-form-group v-if="accident.accident_report_types_id == 1" id="report_type" label-for="type"
                      class="col-sm-2 mr-4" label="Agente del accidente">

                      <select id="type" :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                        v-model="accident.accident_agents_id">
                        <b-form-select-option v-for="tipo4 in agente" :key="tipo4.id" :value="tipo4.id">
                          {{ tipo4.name }}
                        </b-form-select-option>
                      </select>

                    </b-form-group>
                    <b-form-group v-if="accident.accident_report_types_id == 1" id="report_type" label-for="type"
                      class="col-sm-2 mr-4" label="Parte del cuerpo afectada">

                      <select id="type" :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                        v-model="accident.injured_part_bodies_id">
                        <b-form-select-option v-for="tipo5 in parteAfectada" :key="tipo5.id" :value="tipo5.id">
                          {{ tipo5.name }}
                        </b-form-select-option>
                      </select>

                    </b-form-group>
                    <b-form-group v-else id="report_type" label-for="type" class="col-sm-2">

                    </b-form-group>

                  </div>

                  <div class="form-row">

                    <b-form-group class="col-md-6" label="Fecha" label-for="input-sm">
                      <b-form-input :disabled="!getRole('Crear') || !allowAccess()" v-model="accident.report_date"
                        type="date" id="input-sm" placeholder="fecha" :class="{
                          'is-invalid':
                            $v.accident.report_date.$error && submitted,
                        }">

                      </b-form-input>
                      <div v-if="submitted && $v.accident.report_date.$error">
                        <small v-if="!$v.accident.report_date.required" class="text-danger">
                          <b>El campo es requerido</b>
                        </small>
                      </div>
                    </b-form-group>
                    <b-form-group class="col-md-6" label="Hora" label-for="hora">
                      <b-form-input :disabled="!getRole('Crear') || !allowAccess()" v-model="accident.hour" type="time"
                        id="hora" placeholder="" :class="{
                          'is-invalid':
                            $v.accident.hour.$error && submitted,
                        }"></b-form-input>
                      <div v-if="submitted && $v.accident.hour.$error">
                        <small v-if="!$v.accident.hour.required" class="text-danger">
                          <b>El campo es requerido</b>
                        </small>
                      </div>
                    </b-form-group>

                  </div>

                  <div class="form-row">

                    <b-form-group class="col-md-12" label="Lugar" label-for="input-sm">
                      <b-form-input type="text" maxlength="100" :disabled="!getRole('Crear') || !allowAccess()"
                        id="textarea" v-model="accident.site" rows="4" :class="{
                          'is-invalid':
                            $v.accident.site.$error && submitted,
                        }"></b-form-input>
                      <div v-if="submitted && $v.accident.site.$error">
                        <small v-if="!$v.accident.site.required" class="text-danger">
                          <b>El campo es requerido</b>
                        </small>
                      </div>
                    </b-form-group>

                  </div>

                  <div class="form-row">
                    <b-form-group class="col-md-12" label="Descripción de la situación" label-for="input-sm">
                      <b-form-textarea :disabled="!getRole('Crear') || !allowAccess()" id="textarea"
                        v-model="accident.description" rows="4"></b-form-textarea>
                    </b-form-group>

                  </div>
                  <div class="form-row">
                    <b-form-group class="col-md-12" label="Plan de mejora" label-for="input-sm">
                      <b-form-textarea :disabled="!getRole('Crear') || !allowAccess()" id="textarea"
                        v-model="accident.improvement_plan" rows="4"></b-form-textarea>
                    </b-form-group>

                  </div>

                  <div class="form-group text-right m-b-0">
                    <button :disabled="submitted" type="submit" class="btn btn-primary">
                      Guardar
                    </button>
                    <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                      Cancelar
                    </button>
                  </div>

                </div>

                <hr v-if="getRole('Consultar')" />
                <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                  <div class="col-lg-12">
                    <div class="card-body">
                      <div class="row pb-3">
                        <div class="col-6">
                          <div class="form-row row text-center">
                            <form @submit.prevent="fetch()" class="form-inline">
                              <div class="col-sm-11 col-md-5">
                                <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                                  class="form-control px-2" placeholder="Buscar"></b-form-input>
                              </div>
                              <div class="col-sm-1 pl-5">
                                <button type="submit" class="btn btn-primary px-2">Buscar</button>
                              </div>

                            </form>
                          </div>
                        </div>
                        <div class="col-6"></div>
                      </div>

                      <div class="table-responsive">
                        <div v-if="!loading">
                          <table :disabled="!getRole('Consultar') || !allowAccess()"
                            class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                            <thead>
                              <tr>
                                <th>Colaborador</th>
                                <th class="text-center align-middle">Tipo</th>
                                <th class="text-center align-middle">Fecha</th>
                                <th class="text-center align-middle">Descripción</th>
                                <th class="text-center align-middle">Fecha ARL</th>
                                <th class="text-center align-middle">Acciones</th>
                              </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200">
                              <tr :disabled="!getRole('Consultar') || !getRole('Editar') || !allowAccess()"
                                v-for="dato in lista" :key="dato.id">
                                <td>
                                  {{ dato.full_name }}
                                </td>
                                <td class="text-center align-middle">
                                  <div v-if="dato.accident_reports.length > 0">
                                    <div v-if="dato.accident_reports[0].accident_report_types_id === 1">
                                      <h6>Accidente
                                      </h6>
                                    </div>
                                    <div v-else-if="dato.accident_reports[0].accident_report_types_id === 2">
                                      <h6>Incidente
                                      </h6>
                                    </div>
                                    <div v-else-if="dato.accident_reports[0].accident_report_types_id === 3">
                                      <h6>Enfermedad laboral
                                      </h6>
                                    </div>

                                  </div>
                                  <div v-else>
                                    <h6>Sin registros
                                    </h6>
                                  </div>
                                </td>
                                <td class="text-center align-middle">
                                  {{ dato.accident_reports.length > 0 ? dato.accident_reports[0].report_date : 'Sin registro'}}
                                </td>
                                <td class="text-center align-middle">
                                  {{ dato.accident_reports.length > 0 ? dato.accident_reports[0].description : 'Sin registro'}}
                                </td>
                                <td class="text-center align-middle">
                                  {{ dato.accident_reports.length > 0 ? dato.accident_reports[0].arl_report_date : 'Sin registro'}}
                                </td>
                                <td class="text-center align-middle">
                                  <div class="col-sm-12">
                                    <div v-if="dato.accident_reports.length > 0">
                                      <b-dropdown :disabled="(!getRole('Editar') && !getRole('Consultar')) || !allowAccess()
                                        " variant="primary">
                                        <template v-slot:button-content>
                                          <i class="mdi mdi-eye"></i>
                                        </template>

                                        <b-dropdown-item :disabled="(!getRole('Editar') && !getRole('Consultar')) || !allowAccess()
                                          "
                                          :to="{ path: `/forms/estandares/${dato.companies_id}/reporte-accidentes-editar/${dato.accident_reports[0].id}` }">
                                          Editar</b-dropdown-item>
                                        <b-dropdown-item v-if="dato.accident_reports[0].accident_report_types_id === 2"
                                          disabled
                                          :to="{ path: `/forms/estandares/${dato.companies_id}/investigacion-crear/${dato.accident_reports[0].id}` }">
                                          Investigación</b-dropdown-item>
                                        <b-dropdown-item v-else :disabled="!getRole('Consultar') || !allowAccess()"
                                          :to="{ path: `/forms/estandares/${dato.companies_id}/investigacion-crear/${dato.accident_reports[0].id}` }">
                                          Investigación</b-dropdown-item>
                                      </b-dropdown>
                                    </div>
                                    <div v-else>
                                    </div>
                                  </div>
                                </td>

                              </tr>

                            </tbody>
                          </table>
                        </div>
                        <div v-else>
                          <div class="text-center pt-2">
                            <b-spinner variant="primary" label="Loading..."></b-spinner>
                          </div>
                        </div>
                        <div>
                          <Pagination @loading="(load) => (loading = load)" ref="paginator" :search="search"
                            @fetch="(items) => (lista = items)" />
                        </div>

                      </div>
                    </div>
                  </div>
                  <!-- end col -->
                </div>

              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>

      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>